import Modal from '../../../../../commons/Modal/Modal';
import { DashboardIPConsultsCOMFiltersModalProps } from './DashboardIPConsultsCOMFiltersModal.types';
import DashboardIPConsultsCOMFiltersForm from './DashboardIPConsultsCOMFiltersForm/DashboardIPConsultsCOMFiltersForm';
import { ModalSizes } from '../../../../../commons/Modal/Modal.types';

export default ({ ...props }: DashboardIPConsultsCOMFiltersModalProps) => {
  return (
    <Modal 
      className="dashboard__companies-filters" 
      size={ModalSizes.Small} 
      closeOnClickOutside 
      {...props}
    >
      {/* <h2 className="dashboard__companies-filters-title">Filtrer</h2> */}
      <DashboardIPConsultsCOMFiltersForm closeModal={() => props.setOpen(false)} />
    </Modal>
  );
};
